import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import { Dropdown } from 'primereact/dropdown';
import DatePicker from 'react-datepicker';

// CSS
import "./Marcas.scss";
import 'react-datepicker/dist/react-datepicker.css';
import api from "../../../services/apiIdz";
import IdzFileUpload from "../../Veiculos/idzFileUpload";

function MarcasModal({ showMarcas, token, handleAlert, getMarca, closeModalMarcas }) {
    const [showModal, setShowModal] = useState(false);
    const [url, setUrl] = useState("");

    const [marca, setMarca] = useState({
        dt_inclusao: new Date(),
        ordem: 1,
        status: "Ativo"
    })

    useEffect(() => {

    }, [marca])


    const [ativo, setAtivo] = useState(false);

    const handleMarcaData = (value, field) => {
        setMarca({
            ...marca,
            [field]: value
        })
    }

    const handleClose = () => {
        setShowModal(false);
        closeModalMarcas();
    };

    useEffect(() => {
        if (showMarcas) {
            setShowModal(true);
        }
    }, [showMarcas])

    const handleSwitchToggle = () => {
        setAtivo(!ativo);
        console.log(!ativo)
        handleMarcaData(!ativo == 1 ? "Ativo" : "Inativo", "status")
    };

    const handleImagem = (image) => {
        handleMarcaData(image, 'logo')
    }

    const postData = async () => {
        console.log("Enviando marcas")

        await api.post(`/api/marcas-estetica`, marca, {
            headers: {
                'Authorization': process.env.REACT_APP_API_KEY,
                "Token": token
            }
        }).then(r => {
            console.log(r)

            if (typeof r.data == 'string') {
                handleAlert("Campos inválidos", r.data, "danger")
            } else {
                if (r.status == 200) {
                    handleAlert("Sucesso", "Os dados foram cadastrados com êxito.", "success")
                    getMarca()
                    setShowModal(false)
                }
            }
        })
    }

    return ( 
        <>

            <Modal show={showModal} className="ModalMarcasNew">
                <Modal.Header >
                    <Modal.Title>Adicionar Marca</Modal.Title>
                    <Icon icon="mdi:stars"></Icon>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Row>
                            <Col xs={12} sm={12} md={6} lg={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Nome"
                                        value={marca["titulo"]}
                                        onChange={(e) => { handleMarcaData(e.target.value, "titulo") }}

                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={12}>
                                <Form.Group className='Label'>
                                    <Form.Label className='Label'>Descrição</Form.Label>
                                    <textarea
                                        className=""
                                        value={marca["descricao"]}
                                        onChange={(e) => { handleMarcaData(e.target.value, "descricao") }}
                                    ></textarea>

                                </Form.Group>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={12}>
                                <Form.Group className='Label'>
                                    <Form.Label className='Label'>Logo</Form.Label>
                                    <IdzFileUpload currentFile={marca["logo"]} handleUpload={handleImagem} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group>
                            <Form.Check
                                className='Label'
                                type="switch"
                                label={ativo ? "ativo" : "desativado"}
                                checked={ativo}
                                onChange={handleSwitchToggle}
                            ></Form.Check>
                        </Form.Group>
                        <Form.Group className="text-center">
                            <Button variant="primary" onClick={postData} className="Btns ButtonPrimaryLight">
                                Salvar
                            </Button>
                        </Form.Group>
                        <Form.Group className="text-center">
                            <Button variant="secondary" className="Btns ButtonLight" onClick={handleClose}>
                                Fechar
                            </Button>
                        </Form.Group>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default MarcasModal;
